import { render, staticRenderFns } from "./homeTrain.vue?vue&type=template&id=43d444ca&scoped=true&"
import script from "./homeTrain.vue?vue&type=script&lang=js&"
export * from "./homeTrain.vue?vue&type=script&lang=js&"
import style0 from "./homeTrain.vue?vue&type=style&index=0&id=43d444ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d444ca",
  null
  
)

component.options.__file = "homeTrain.vue"
export default component.exports